<style lang="less">
  // @import '../flow.less';
  @import '../base.less';
</style>

<template>
    <div class="content">
      <div class="main">
          <div>
              <Row>
                  <Col span="24" :md="15">
                      <Row class="title">
                          <h4>项目工作流详情</h4>
                      </Row>
                      <div class="info-property">
                          <dl>
                              <dt>申请人</dt><dd>{{detail.user}}</dd>
                          </dl>
                          <dl>
                              <dt>项目名</dt><dd>{{detail.name}}</dd>
                          </dl>
                          <dl>
                              <dt>项目Code</dt><dd>{{detail.name_en}}</dd>
                          </dl>
                          <dl>
                              <dt>项目经理</dt><dd>{{detail.masters}}</dd>
                          </dl>
                          <dl>
                              <dt>产品经理</dt><dd>{{detail.pms}}</dd>
                          </dl>
                          <dl>
                              <dt>开发人员</dt><dd>{{detail.developers}}</dd>
                          </dl>
                          <dl>
                              <dt>测试人员</dt><dd>{{detail.tests}}</dd>
                          </dl>
                          <dl>
                              <dt>维护人员</dt><dd>{{detail.maintain}}</dd>
                          </dl>
                            <dl>
                              <dt>项目描述</dt><dd>{{detail.description}}</dd>
                          </dl>
                          <dl>
                              <dt>状态</dt><dd>{{detail.status}}</dd>
                          </dl>
                          <dl>
                              <dt>申请时间</dt><dd>{{detail.time_start}}</dd>
                          </dl>
                          <dl>
                              <dt>完成时间</dt><dd>{{detail.time_end ? detail.time_end : '---'}}</dd>
                          </dl>
                      </div>
                      <Row className="margin-top-10">
                        <Row class="title">
                            <h4>审批</h4>
                        </Row>
                        <Approves :approves = "detail.approves" approveType = "projectflow" :reFresh= "this.handleReFresh" :status = "detail.status" />
                      </Row>
                   </Col>
                   <Col span="24" :md="{ span: 8, offset: 1 }" class="mob-mt-20">
                      <div class="title">
                          <h4>日志信息</h4>
                      </div>
                      <FlowLogs :logs = "detail.logs" />
                  </Col>
              </Row>
            </div>
      </div>
  </div>
</template>
<script>
import { getProjectFlowDetail } from '@/api/projectflow'
import Approves from '../base/Approves'
import FlowLogs from '../base/Logs'
export default {
  name: 'ProjectFlowDetail',
  components: {
    'Approves': Approves,
    'FlowLogs': FlowLogs
  },
  data () {
    return {
      detail: {}
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.getProjectFlowDetail(this.$route.query.id)
      }
    }
  },
  methods: {
    getProjectFlowDetail (id) {
      let params = {
        id: id
      }
      getProjectFlowDetail(params).then(res => {
        this.detail = res.data
      })
    },
    handleReFresh () {
      // 处理刷新操作
      this.getProjectFlowDetail(this.$route.query.id)
    }
  },
  mounted: function () {
    this.getProjectFlowDetail(this.$route.query.id)
  }
}
</script>
